import { render, staticRenderFns } from "./labelmanagetable.vue?vue&type=template&id=1b072c62&scoped=true&"
import script from "./labelmanagetable.vue?vue&type=script&lang=js&"
export * from "./labelmanagetable.vue?vue&type=script&lang=js&"
import style0 from "./labelmanagetable.vue?vue&type=style&index=0&id=1b072c62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b072c62",
  null
  
)

export default component.exports